<template>
  <div class="notice-container">
    <h2>编辑通知公告</h2>
    <!-- 使用容器包裹表单元素 -->
    <div class="form-container">
      <textarea 
        v-model="noticeContent" 
        placeholder="输入通知公告内容"
        class="notice-textarea"
      ></textarea>
      <button @click="saveNotice" class="save-btn">保存</button>
      <!-- 添加消息提示容器 -->
      <div class="message-container">
        <p v-if="successMessage" class="success">{{ successMessage }}</p>
        <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
      </div>
    </div>
    <footers />
  </div>
</template>

<script>
import Footers from '../components/footer.vue';

export default {
  components: {
    Footers
  },
  data() {
    return {
      noticeContent: '',
      successMessage: '',
      errorMessage: ''
    };
  },
  methods: {
    async saveNotice() {
      try {
        const response = await this.$http.post('notices', { content: this.noticeContent });
        console.log('保存的通知公告内容：', response);
        this.successMessage = '通知公告保存成功';
        this.errorMessage = ''; // 清空错误提示
        this.noticeContent = ''; // 清空输入框
      } catch (error) {
        console.error('保存通知公告失败:', error);
        this.errorMessage = '保存通知公告失败，请重试';
        this.successMessage = ''; // 清空成功提示
      }
    }
  }
};
</script>

<style scoped>
/* 总容器 */
.notice-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}
h2{
  text-align: center;
}
/* 表单容器 */
.form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  max-width: 80%;
  margin: 0 auto;
}

/* 输入框样式 */
.notice-textarea {
  width: 100%;
  height: 300px;
  padding: 15px;
  font-size: 16px;
  resize: none;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 按钮样式 */
.save-btn {
  padding: 12px 30px;
  font-size: 16px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.save-btn:hover {
  background-color: #45a049;
}

/* 消息提示样式 */
.message-container {
  width: 100%;
  text-align: center;
}

.success {
  color: #28a745;
  font-weight: bold;
}

.error {
  color: #dc3545;
  font-weight: bold;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .form-container {
    max-width: 90%;
  }
}
</style>